import { ChevronDown, Globe2 } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuRadioGroup, DropdownMenuRadioItem,
} from "./ui/dropdown-menu";

const Flag = ({ language }) => (
  <span aria-hidden="true" className={`language-flag language-flag-${language}`} />
);

export const LanguageSelector = () => {
  const { language, preference, selectLanguage, t } = useLanguage();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="language-menu-trigger" className="language-trigger" aria-label={t("Select language")}
          title={t("Select language")}>
          <Flag language={language} />
          <span data-testid="language-current-label" className="font-mono text-xs uppercase">{language}</span>
          <ChevronDown size={13} className="language-chevron text-slate-500" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent data-testid="language-menu" align="end" sideOffset={12}
        className="z-50 w-60 rounded-lg border-[#282C3D] bg-[#141620] p-2 text-slate-200 shadow-2xl">
        <DropdownMenuLabel className="px-2 py-2 font-mono text-[10px] uppercase text-slate-500">
          {t("Language")}
        </DropdownMenuLabel>
        <DropdownMenuRadioGroup value={preference} onValueChange={selectLanguage} data-testid="language-options">
          <DropdownMenuRadioItem value="auto" data-testid="language-option-auto" className="cursor-pointer gap-2.5 rounded-md py-3 focus:bg-[#1A1D2B] focus:text-[#FFC857]">
            <Globe2 size={18} className="text-slate-400" />
            <span>{t("Automatic")}</span>
            <span className="ml-auto font-mono text-[10px] uppercase text-slate-500">{language}</span>
          </DropdownMenuRadioItem>
          <DropdownMenuSeparator className="my-1 bg-[#282C3D]" />
          {[{ code: "de", name: "Deutsch" }, { code: "en", name: "English" }].map(({ code, name }) => (
            <DropdownMenuRadioItem key={code} value={code} data-testid={`language-option-${code}`}
              className="cursor-pointer gap-2.5 rounded-md py-3 focus:bg-[#1A1D2B] focus:text-[#FFC857]">
              <Flag language={code} /><span lang={code}>{name}</span>
              <span className="ml-auto font-mono text-[10px] uppercase text-slate-500">{code}</span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};